import { api } from "api/api";
import { AxiosError } from "axios";
import SerieNotaFiscal from "model/fiscal/SerieNotaFiscal";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class SerieNotaFiscalService implements BaseServiceCadastros<SerieNotaFiscal> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/serieNotaFiscal/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<SerieNotaFiscal>((resolve, reject): void => {
            api
                .get(`/serieNotaFiscal/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(serieNotaFiscal: SerieNotaFiscal) {
        return new Promise<SerieNotaFiscal>((resolve, reject): void => {
            api
                .post(`/serieNotaFiscal/incluir`, JSON.stringify(serieNotaFiscal))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(serieNotaFiscal: SerieNotaFiscal) {
        return new Promise<SerieNotaFiscal>((resolve, reject): void => {
            api
                .put(`/serieNotaFiscal/editar`, JSON.stringify(serieNotaFiscal))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/serieNotaFiscal/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getListaModelo() {
        return [
            { value: "NFE", label: "NF-e" },
            { value: "NFCE", label: "NFC-e" }
        ];
    }

    getModelo(modelo: string) {
        return this.getListaModelo().find(item => item.value === modelo)?.label || "";
    }

    getListaAmbiente() {
        return [
            { value: "HOMOLOGACAO", label: "Homologação" },
            { value: "PRODUCAO", label: "Produção" }
        ];
    }

    getAmbiente(ambiente: string) {
        return this.getListaAmbiente().find(item => item.value === ambiente)?.label || "";
    }

    getListaAmbienteFilter() {
        return this.getListaAmbiente().map(item => ({ label: item.label, value: item.value }));
    }

    getListaControleNumeracao() {
        return [
            { value: "EMPX", label: "Numeração controlada pelo Empx" }
        ];
    }

    getControleNumeracao(controleNumeracao: string) {
        return this.getListaControleNumeracao().find(item => item.value === controleNumeracao)?.label || "";
    }

}
export default SerieNotaFiscalService;
